import {WorkflowTransition} from '@nh/angular-tses';

export class Graph {
  // A representation of the graph as a record of nodes and their corresponding edges
  public nodes: Record<string, string[]> = {};

  constructor(transitions: WorkflowTransition[]) {
    this.setNodes(transitions);
  }

  /**
   * Builds the nodes graph representation as a record of nodes and their corresponding edges.
   *
   * @param transitions The workflow state graph as an array of edges
   */
  private setNodes(transitions: WorkflowTransition[]) {
    transitions.forEach(t => {
      if (this.nodes[t.from]) {
        this.nodes[t.from].push(t.to);
      } else {
        this.nodes[t.from] = [t.to];
      }
    });
  }

  /**
   * Returns a path from the start node to the target if such a path exists, otherwise returns null.
   *
   * @param start the start node of the path
   * @param target the target node of the path
   */
  public getPath(start: string, target: string): string[] {
    return this.recurseDownGraph(start, target, []);
  }

  public getPotentialNodes(node: string): string[] {
    return this.nodes[node] || [];
  }

  /**
   * Recursively walks through a graph looking for a non-looping path to the target node.
   * Once it finds this it recurses back and returns the path that got it there. If no such
   * path exists then returns null.
   *
   * NOTE: this function may not find the shortest non-looping path to the target node
   * if two such paths exist.
   *
   * @param node the current node on the workflow graph
   * @param path the current path that has been walked
   * @param graph the graph, as a set of nodes and their edges, that is being traversed
   */
  private recurseDownGraph(node: string, target: string, path: string[]): string[] {
    if (path.includes(node)) {
      return null;
    }
    path.push(node);
    if (node === target) {
      return path;
    } else if (!this.nodes[node]) {
      return null;
    } else {
      for (let i = 0; i < this.nodes[node].length; i++) {
        const p = this.recurseDownGraph(this.nodes[node][i], target, path.slice());
        if (p) {
          return p;
        }
      }
      return null;
    }
  }
}
